<template>
  <!-- 処方値修正 -->
  <div id="AppPrescriptionEdit">
    <!-- 上部余白 -->
    <div style="height: 10px;" />
    <div class="box" style="margin-left: 50px; margin-Right: 50px;">
      <div class="columns">
        <div class="column is-full">
          <label v-if="isEdit" class="searchTitle label">処方値修正</label>
          <label v-else class="searchTitle label">処方値参照</label>
        </div>
      </div>

      <div style="margin-left: 30px; margin-Right: 30px;">
        <!-- 詳細表示 -->
        <div style="detailArea">
          <section v-if="isEdit">
            <div style="height:10px;"></div>
            <table class="table" style="width: 100%;">
              <tr style="font-size: 16px;">
                <td style="width: 150px;">患者コード</td>
                <td>{{ inspectionItem.patientCode }}</td>
              </tr>
              <tr style="font-size: 16px;">
                <td>患者名</td>
                <td>{{ inspectionItem.patientName }}</td>
              </tr>
              <tr style="font-size: 16px;">
                <td>医療機関</td>
                <td>{{ inspectionItem.hospitalName }}</td>
              </tr>
              <tr style="font-size: 16px;">
                <td>診療科</td>
                <td>{{ inspectionItem.department }}</td>
              </tr>
              <tr style="font-size: 16px;">
                <td>担当医</td>
                <td>{{ inspectionItem.doctorName }}</td>
              </tr>
              <tr style="font-size: 16px;">
                <td>品目名</td>
                <td>{{ productName }}</td>
              </tr>
              <tr style="font-size: 16px;">
                <td>シリアル</td>
                <td>
                  <span v-if="!inspectionItem.newSerialNumber">
                    {{ inspectionItem.serialNumber }}
                    <b-button
                      class="button is-primary has-text-centered"
                      icon-left="repeat"
                      native-type="button"
                      id="machineReplaceButton"
                      style="float: right;"
                      v-on:click="showSerialReader()"
                    >機器交換</b-button>
                    <b-modal
                      :active.sync="isSerialReaderModalActive"
                      has-modal-card
                      full-screen
                    >
                      <reader-modal
                        v-on:resolve="resolveSerial"
                      ></reader-modal>
                    </b-modal>
                  </span>
                  <span v-else>
                    {{ inspectionItem.serialNumber }} ⇒ {{ inspectionItem.newSerialNumber }}
                    <b-button
                      class="button is-primary has-text-centered"
                      icon-left="repeat"
                      native-type="button"
                      id="machineReplaceButton"
                      style="float: right;"
                      v-on:click="clearSerial()"
                    >機器交換キャンセル</b-button>
                  </span>
                </td>
              </tr>
              <tr style="font-size: 16px;">
                <td>処方値変更理由</td>
                <td>
                  <table>
                    <thead style="border-bottom: 3px double lightgray">
                      <tr>
                        <td style="font-size: 16px;width:16%;">変更日時</td>
                        <td style="font-size: 16px;width:15%;">更新者</td>
                        <td style="font-size: 16px;width:10%;">変更種別</td>
                        <td style="font-size: 16px;width:15%;">変更項目</td>
                        <td style="font-size: 16px;width:10%;">変更前</td>
                        <td style="font-size: 16px;width:10%;">変更後</td>
                        <td style="font-size: 16px;width:24%;">変更理由
                          <b-button
                            class="button is-primary has-text-centered"
                            native-type="button"
                            style="float: right;left:14px;"
                            icon-left="history"
                            v-on:click="prescriptionHistoryModalActive = true"
                          >処方値変更履歴</b-button>
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="lastPreEditHistory">
                        <td style="font-size: 16px;">{{ lastPreEditHistory.updatedDay }}</td>
                        <td style="font-size: 16px;word-break:break-all;">{{ lastPreEditHistory.staffName }}</td>
                        <td style="font-size: 16px;">{{ lastPreEditHistory.type }}</td>
                        <td style="font-size: 16px;">{{ lastPreEditHistory.displayName }}</td>
                        <td style="font-size: 16px;">{{ lastPreEditHistory.beforeValue }}</td>
                        <td style="font-size: 16px;">{{ lastPreEditHistory.afterValue }}</td>
                        <td style="font-size: 16px;word-break:break-all;">{{ lastPreEditHistory.doctorChangeReason }}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr style="font-size: 16px;" v-if="machineType == 8">
                <td style="border-bottom: solid 1px;">療法（呼吸のみ）</td>
                <td style="border-bottom: solid 1px;">
                  <b-field
                    :type="{'is-danger':errors.has('therapy')}"
                    :message="errors.first('therapy')"
                  >
                    <b-select v-model="therapy" name="therapy" data-vv-as="療法（呼吸のみ）" expanded>
                      <option value="NPPV">NPPV</option>
                      <option value="TPPV">TPPV</option>
                      <option value="HFT">HFT</option>
                      <option value="NPPV/HFT">NPPV/HFT</option>
                      <option value="TPPV/HFT">TPPV/HFT</option>
                    </b-select>
                  </b-field>
                </td>
              </tr>
              <tr style="font-size: 16px;" v-if="machineType == 7">
                <td>メイン設定</td>
                <td>
                  <b-select expanded v-model="inspectionItem.mainSetting">
                    <option
                      v-for="setting in trilogyEvoMainSetting"
                      :key="setting.code"
                      :value="setting.code"
                    >
                      {{ setting.name }}
                    </option>
                  </b-select>
                </td>
              </tr>
              <tr style="font-size: 16px;">
                <b-button
                  style="margin-left:10px; margin-top:10px;"
                  class="button is-primary has-text-centered"
                  icon-left="folder-upload"
                  native-type="button"
                  v-on:click="getDisposableList(inspectionItem.patientCode,inspectionItem.patientName)"
                >消耗品発送登録</b-button>
              </tr>
            </table>
            <!-- ボンベシリアルリストモーダル -->
            <b-modal :active.sync="serialInputModalActive.flg" has-modal-card>
              <serialInput-modal
                v-bind:index="serialInputModalActive.index"
                v-bind:serial-list="serialInputModalActive.list"
                v-bind:serial-type="serialInputModalActive.serialType"
                v-bind:d-name="serialInputModalActive.dName"
                v-bind:d-number="serialInputModalActive.dNumber"
                v-bind:machineType="machineType"
                v-on:serial-input-event="serialChanged"
                v-on:single-item-serial-reader="singleItemSerialReader"
                full-screen
              ></serialInput-modal>
            </b-modal>
            <!-- シリアル読み取りモーダル -->
            <b-modal :active.sync="isSerialPuroductReaderModalActive" has-modal-card full-screen>
              <serialProductReader-modal
                v-bind:serial-type="serialInputModalActive.serialType"
                v-bind:index="serialPuroductListIndex"
                v-bind:d-name="serialInputModalActive.dName"
                v-bind:d-number="serialInputModalActive.dNumber"
                v-on:serial-input-event="serialChanged"
              ></serialProductReader-modal>
            </b-modal>
            <div class="columns"></div>
            <div style="height:10px;"></div>
            <div class="columns header">
              <div class="column is-1">No.</div>
              <div class="column is-3" style="text-align:left;">点検内容</div>
              <div class="column is-4" style="text-align:left;">処方値</div>
              <div class="column is-3" style="text-align:left;">変更値</div>
            </div>
            <template v-for="(content, index) in inspectionItem.value">
              <template v-if="!hiddenNotSap || content.sap || content.displayName == '処方値変更理由'">
                <heading-comp
                  v-if="index == 0"
                  v-bind:key="'sapStartTitle'+index"
                  v-bind:color="'backgroundColor: #209cee;'"
                  v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                  v-bind:value1="'処方値(患者DB連携項目)'"
                ></heading-comp>
                <heading-comp
                  v-if="content.displayName == '換気モード(Prog2)'"
                  v-bind:key="'sapStartTitle'+index"
                  v-bind:color="'backgroundColor: #209cee;'"
                  v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                  v-bind:value1="'処方値(患者DB連携項目)(Prog2)項目'"
                ></heading-comp>
                <heading-comp
                  v-if="content.displayName == '換気モード(Prog3)'"
                  v-bind:key="'sapStartTitle'+index"
                  v-bind:color="'backgroundColor: #209cee;'"
                  v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                  v-bind:value1="'処方値(患者DB連携項目)(Prog3)項目'"
                ></heading-comp>
              <heading-comp
                v-if="notSapItemName == content.displayName"
                v-bind:key="'sapEndTitle'+index"
                v-bind:color="'backgroundColor: #209cee;'"
                v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                v-bind:value1="''"
              ></heading-comp>
              <heading-comp
                v-if="notSapItemName == content.displayName"
                v-bind:key="'notSapStartTitle'+index"
                v-bind:color="'backgroundColor: #000894;'"
                v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                v-bind:value1="'処方値以外(患者DB連携項目外)'"
              ></heading-comp>
                <heading-comp
                  v-if="content.displayName == 'PS(Prog2)'"
                  v-bind:key="'notSapStartTitle'+index"
                  v-bind:color="'backgroundColor: #000894;'"
                  v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                  v-bind:value1="'処方値以外(患者DB連携項目外)(Prog2)項目'"
                ></heading-comp>
                <heading-comp
                  v-if="content.displayName == 'PS(Prog3)'"
                  v-bind:key="'notSapStartTitle'+index"
                  v-bind:color="'backgroundColor: #000894;'"
                  v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                  v-bind:value1="'処方値以外(患者DB連携項目外)(Prog3)項目'"
                ></heading-comp>
                <heading-comp
                  v-if="content.displayName == '換気モード(Prog4)'"
                  v-bind:key="'notSapStartTitle'+index"
                  v-bind:color="'backgroundColor: #000894;'"
                  v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                  v-bind:value1="'処方値以外(患者DB連携項目外)(Prog4)項目'"
                ></heading-comp>
                <!-- LUISA -->
                <heading-comp
                  v-if="content.displayName == '換気モード'"
                  v-bind:key="'LuisaMachineinspection1_'+index"
                  v-bind:color="addSubSystemStyleBackColorOpacity(null, 0.8)"
                  v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                  v-bind:value1="'プログラム'+(content.contentsType - 1)"
                ></heading-comp>
                <heading-comp
                  v-if="content.displayName == '運転時間'"
                  v-bind:key="'LuisaMachineinspection2_'+index"
                  v-bind:color="addSubSystemStyleBackColorOpacity(null, 0.8)"
                  v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                  v-bind:value1="'点検項目(※非装着時点検項目)'"
                ></heading-comp>
                <!-- クリアウェイ2 -->
                <heading-comp
                  v-if="content.displayName == 'プロファイル使用'"
                  v-bind:key="'crealWay2Machineinspection1_'+index"
                  v-bind:color="addSubSystemStyleBackColorOpacity(null, 0.8)"
                  v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                  v-bind:value1="'プロファイル'+(content.contentsType - 1)"
                ></heading-comp>
                <heading-comp
                  v-if="content.displayName == '吸気圧測定値（40hPa）'"
                  v-bind:key="'crealWay2Machineinspection2_'+index"
                  v-bind:color="addSubSystemStyleBackColorOpacity(null, 0.8)"
                  v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                  v-bind:value1="'確認項目'"
                ></heading-comp>

                <!-- 見出し表示共通化 -->
                <template 
                  v-if="header(content)"
                >
                  <heading-comp
                    v-for="(header, headerIndex) in header(content)"
                    :key="'header-' + index + '-' + headerIndex"
                    :color="'backgroundColor: ' + header.backgroundColor"
                    text-style="font-size:15px; font-weight: bold; color:white;"
                    :prefix="header.getPrefix ? header.getPrefix(inspectionItem.mainSetting, content.contentsType) : ''"
                    :value1="header.headerName"
                    style="margin-bottom: 0.75rem"
                  ></heading-comp>
                </template>

                <div class="columns row" v-bind:key="index" v-bind:style="addStyleBackColor(content.value,content.displayName)">
                  <div class="column is-1">{{index + 1}}</div>
                  <div class="column is-3" style="text-align:left;">
                    <span v-if="content.displayName">
                      {{ displayName(content) }}
                      <br />
                    </span>
                    <span v-if="machineType == 8">
                      <span>{{annotationItemMap[content.displayName]}}</span>
                    </span>
                    {{ content.note }}
                    {{ content.content}}
                  </div>
                  <template v-if="content.type=== 'char'">
                    <div
                      class="column is-3"
                      style="text-align:left;white-space:pre-line;"
                    >{{ getPrescriptionValue(content.prescription) }} {{ isShowUintLabel(content.prescription, content.unit) }}</div>
                    <div
                      v-if="isShowClear(content)"
                      class="column is-1"
                      style="text-align:left"
                    >
                      <b-field
                        label
                        labelPosition="on-border"
                      > 
                        <b-checkbox
                          true-value="true"
                          false-value="false"
                          :id="content.isClear + index"
                          v-model="content.isClear"
                        >クリア</b-checkbox>
                      </b-field>
                    </div>
                    <div v-else class="column is-1"/>
                    <div class="column">
                      <b-field
                        label
                        labelPosition="on-border"
                        :type="{'is-danger':errors.has(getInputFieldName(index))}"
                        :message="errors.first(getInputFieldName(index))"
                        style="text-align:left;"
                      >
                        <span
                          style="text-align:left;white-space:pre-line;"
                          v-if="(machineType==8 && (content.displayName == '加湿器1（品目テキスト）(Prog1)' || content.displayName == '加湿器2（品目テキスト）(Prog1)')) || isDisable(content.value,content.displayName)"
                        >{{content.value}}</span>
                        <b-input
                          v-else
                          :id="index"
                          :name="getInputFieldName(index)"
                          @blur="inputValue(content)"
                          :expanded="true"
                          v-model="content.value"
                          size="is-small"
                          data-vv-as="処方値を変更する場合、処方値変更理由"
                          v-validate="`${content.displayName=='処方値変更理由' ?'required':''}|validationCeheck:${index}|${prismaAnotherInputItems[content.displayName]?'checkProduct':''}`"
                        ></b-input>
                        <span v-if="content.unit" style="margin-left:10px;">{{content.unit}}</span>
                      </b-field>
                      <b-field>
                        <span
                          v-if="limitCheck(content, index, machineType)"
                          style="color:red;"
                        >下限が上限値を超えています。</span>
                      </b-field>
                      <b-button
                        v-if="serialInputType(content.displayName) == 1"
                        style="float:left;"
                        class="button is-primary has-text-centered"
                        native-type="button"
                        id="Button"
                        v-on:click="serialInput(content, index)"
                      >シリアルNO入力</b-button>
                      <b-button
                        v-else-if="serialInputType(content.displayName) == 2"
                        style="float:left;"
                        class="button is-primary has-text-centered"
                        native-type="button"
                        id="Button"
                        v-on:click="serialInput(content, index)"
                        icon-left="camera"
                      >シリアルNO読み取り</b-button>
                    </div>
                  </template>
                  <template v-else-if="content.type=== 'sel'">
                    <div
                      class="column is-3"
                      style="text-align:left;"
                    >{{ getSelectValue(content.displayValue,content.prescription) }} {{ isShowUintLabel(content.prescription, content.unit) }}</div>
                    <div
                      v-if="isShowClear(content)"
                      class="column is-1"
                      style="text-align:left"
                    >
                      <b-field
                        label
                        labelPosition="on-border"
                      > 
                        <b-checkbox
                          true-value="true"
                          false-value="false"
                          :id="content.isClear + index"
                          v-model="content.isClear"
                        >クリア</b-checkbox>
                      </b-field>
                    </div>
                    <div v-else class="column is-1"/>
                    <div class="column">
                      <b-field label labelPosition="on-border">
                        <b-select
                          expanded
                          size="is-small"
                          :name="getSelectFieldName(index+1)"
                          v-model="content.value"
                        >
                          <option
                            v-for="option in content.displayValue"
                            :value="option.key"
                            :key="option.key"
                            :name="getSelectFieldName(index+1)"
                            :disabled="isDisable(option.value,content.displayName)"
                            v-bind:style="addStyleBackColor(option.value,content.displayName)"
                          >{{ option.value }}</option>
                        </b-select>
                        <span style="margin-left:10px;" v-if="content.unit">{{content.unit}}</span>
                      </b-field>
                    </div>
                  </template>
                  <template v-else-if="content.type=== 'radio'">
                    <div class="column is-1"/>

                    <div class="column" style="text-align:left;">
                      <div class="column" style="text-align: left;">
                        <b-radio
                          v-for="displayValue in content.displayValue"
                          :value="displayValue.value"
                          :key="displayValue.value"
                          :native-value="content.value"
                          :name="getRadioFieldName(index)"
                          @click.native="inputRadioValue(index,displayValue.value)"
                        >{{displayValue.value}}</b-radio>
                      </div>
                    </div>
                  </template>
                  <template v-if="content.type=== 'text'">
                    <div class="column is-1"/>

                    <div class="column" style="text-align:left;">
                      <b-field>
                        <b-input expanded="true" v-model="content.value" size="is-small"></b-input>
                        <span style="margin-left:10px;" v-if="content.unit">{{content.unit}}</span>
                      </b-field>
                    </div>
                  </template>
                </div>
              </template>

              <heading-comp
                v-if="index == inspectionItem.value.length-1"
                v-bind:key="'notSapEndTitle'+index"
                v-bind:color="'backgroundColor: #000894;'"
                v-bind:text-style="'font-size:15px; font-weight: bold; color:white;'"
                v-bind:value1="''"
              ></heading-comp>
            </template>
          </section>
          <section v-else>
            <div style="height:10px;"></div>
            <table class="table" style="width: 100%;">
              <tr style="font-size: 16px;">
                <td style="width: 150px;">患者コード</td>
                <td>{{ inspectionItem.patientCode }}</td>
              </tr>
              <tr style="font-size: 16px;">
                <td>患者名</td>
                <td>{{ inspectionItem.patientName }}</td>
              </tr>
              <tr style="font-size: 16px;">
                <td>医療機関</td>
                <td>{{ inspectionItem.hospitalName }}</td>
              </tr>
              <tr style="font-size: 16px;">
                <td>診療科</td>
                <td>{{ inspectionItem.department }}</td>
              </tr>
              <tr style="font-size: 16px;">
                <td>担当医</td>
                <td>{{ inspectionItem.doctorName }}</td>
              </tr>
              <tr style="font-size: 16px;">
                <td>品目名</td>
                <td>{{ inspectionItem.productName }}</td>
              </tr>
              <tr style="font-size: 16px;">
                <td>シリアル</td>
                <td>{{ inspectionItem.serialNumber }}</td>
              </tr>
              <tr style="font-size: 16px;">
                <td>処方値変更理由</td>
                <td>
                  <table>
                    <thead style="border-bottom: 3px double lightgray">
                      <tr>
                        <td style="font-size: 16px;width:16%;">変更日時</td>
                        <td style="font-size: 16px;width:15%;">更新者</td>
                        <td style="font-size: 16px;width:10%;">変更種別</td>
                        <td style="font-size: 16px;width:15%;">変更項目</td>
                        <td style="font-size: 16px;width:10%;">変更前</td>
                        <td style="font-size: 16px;width:10%;">変更後</td>
                        <td style="font-size: 16px;width:24%;">変更理由
                          <b-button
                            class="button is-primary has-text-centered"
                            native-type="button"
                            style="float: right;left:14px;"
                            icon-left="history"
                            v-on:click="prescriptionHistoryModalActive = true"
                          >処方値変更履歴</b-button>
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style="font-size: 16px;">{{ lastPreEditHistory.updatedDay }}</td>
                        <td style="font-size: 16px;word-break:break-all;">{{ lastPreEditHistory.staffName }}</td>
                        <td style="font-size: 16px;">{{ lastPreEditHistory.type }}</td>
                        <td style="font-size: 16px;">{{ lastPreEditHistory.displayName }}</td>
                        <td style="font-size: 16px;">{{ lastPreEditHistory.beforeValue }}</td>
                        <td style="font-size: 16px;">{{ lastPreEditHistory.afterValue }}</td>
                        <td style="font-size: 16px;word-break:break-all;">{{ lastPreEditHistory.doctorChangeReason }}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr style="font-size: 16px;" v-if="machineType == 8">
                <td>療法（呼吸のみ）</td>
                <td>{{therapy}}</td>
              </tr>
              <tr style="font-size: 16px;" v-if="machineType == 7">
                <td>メイン設定</td>
                <td>{{inspectionItem.mainSetting != null ? trilogyEvoMainSetting.find(elem => elem.code == inspectionItem.mainSetting).name : ""}}</td>
              </tr>
            </table>
            <div class="columns"></div>
            <div style="height:10px;"></div>
            <div class="columns header">
              <div class="column is-2" style="text-align:left;">No.</div>
              <div class="column is-5" style="text-align:left; margin-left:10px;">点検内容</div>
              <div class="column is-5" style="text-align:left; margin-left:10px;">処方値</div>
            </div>
            <template v-for="(content, index) in inspectionItem.value">
              <template v-if="!hiddenNotSap || content.sap || content.displayName == '処方値変更理由'">
                <heading-comp
                  v-if="displaHeading(content)"
                  v-bind:key="'heading' + index"
                  v-bind:color="addSubSystemStyleBackColorOpacity(null, 0.4)"
                ></heading-comp>
                <!-- 見出し表示共通化 -->
                <template
                  v-if="header(content)"
                >
                  <heading-comp
                    v-for="(header, headerIndex) in header(content)"
                    :key="'header-' + index + '-' + headerIndex"
                    :color="'backgroundColor: ' + header.backgroundColor"
                    text-style="font-size:15px; font-weight: bold; color:white;"
                    :prefix="header.getPrefix ? header.getPrefix(inspectionItem.mainSetting, content.contentsType) : ''"
                    :value1="header.headerName"
                    style="margin-bottom: 0.75rem"
                  ></heading-comp>
                </template>

                <div class="columns row" v-bind:key="index">
                  <div class="column is-2" style="text-align:left; margin-left:10px;">{{index + 1}}</div>
                  <div class="column is-5" style="text-align:left;">
                    <span v-if="content.displayName">
                      {{ displayName(content) }}
                      <br />
                    </span>
                    {{ content.content }}
                  </div>
                  <template v-if="content.type=== 'char'">
                    <div
                      class="column is-5"
                      style="text-align:left;white-space:pre-line;"
                      v-if="content.prescription"
                    >{{ getPrescriptionValue(content.prescription) }} {{ isShowUintLabel(content.prescription, content.unit) }}</div>
                    <div
                      class="column is-5"
                      style="text-align:left;white-space:pre-line;"
                      v-else
                    >{{ content.value}} {{ isShowUintLabel(content.value, content.unit) }}</div>
                    <div class="column"></div>
                  </template>
                  <template v-else-if="content.type=== 'sel'">
                    <div
                      class="column is-5"
                      style="text-align:left;"
                    >{{ getSelectValue(content.displayValue,content.prescription) }} {{ isShowUintLabel(content.prescription, content.unit) }}</div>
                    <div class="column"></div>
                  </template>
                </div>
              </template>
            </template>
          </section>
        </div>
        <b-modal :active.sync="isRegularDisposablesOrderModalActive" full-screen>
          <regular-disposables-modal
            v-on:set-regular-disposables-data="setDisposablesData"
            v-bind:disposablesByDevice="teikishoumouData.disposablesByDevice"
            v-bind:interval="teikishoumouData.interval"
            v-bind:previousDate="teikishoumouData.previousDate"
            v-bind:patientCode="targetPatientCode"
            v-bind:patientName="targetPatientName"
          ></regular-disposables-modal>
        </b-modal>
        <b-modal :active.sync="prescriptionHistoryModalActive" has-modal-card full-screen>
          <prescription-history-modal v-bind:targetData="preEditHistoryList"></prescription-history-modal> 
        </b-modal>
      </div>
    </div>
    <!-- 下部余白 -->
    <div style="height: 10px;" />
    <!-- 戻るボタン -->
    <div style="text-align:center;">
      <b-button
        v-on:click="back"
        class="button"
        type="is-primary"
        icon-left="keyboard-backspace"
        native-type="button"
      >戻る</b-button>
      <b-button
        class="button is-primary has-text-centered"
        icon-left="folder-upload"
        native-type="button"
        v-on:click="save"
        v-if="isEdit"
      >登録</b-button>
      
    </div>
  </div>
</template>

<script>
import Quagga from "quagga";
import regulardisposablesOderTemplate from "./AppRegularDisposablesOrder";
var canvas;
var ctx;
var moveflg = 0;
var Xpoint = 0;
var Ypoint = 0;
var signFlg = false;
// 初期値（サイズ、色、アルファ値）の決定
var defSize = 5;
var defColor = "#555";
var cnt = 0;

// ネイティブアプリとやりとりするためのPromise
window.nativePromises = {};
function generateUUID() {
  var d = new Date().getTime();
  var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(
    c
  ) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
  return uuid;
}
window.resolvePromise = function(promiseId, data, error) {
  if (error) {
    window.nativePromises[promiseId].reject(data);
  } else {
    window.nativePromises[promiseId].resolve(data);
  }
  // remove referenfe to stored promise
  delete window.nativePromises[promiseId];
};

const RegularDisposablesTemplate = {
  components: {
    regularDisposablesOder: regulardisposablesOderTemplate
  },
  props: [
    "disposablesByDevice",
    "interval",
    "previousDate",
    "patientCode",
    "patientName"
  ],
  data() {
    // 定期消耗品の編集が可能か判定するフラグ
    var activeFlag = false;
    var now = new Date();
    // 次月
    var nextMonth = now.getMonth() + 2;
    if (nextMonth > 12) {
      nextMonth = parseInt(nextMonth % 12);
    }

    // 発送予定月算出
    var beforeDate = new Date(this.previousDate);
    var targetMonth = beforeDate.getMonth() + 1;
    targetMonth = targetMonth + parseInt(this.interval);
    if (targetMonth > 12) {
      targetMonth = parseInt(targetMonth % 12);
    }

    if (targetMonth == nextMonth) {
      // 発送予定月が次月
      var day = now.getDate();
      if (day < 6) {
        activeFlag = true;
      }
    } else {
      // 発送予定月が2か月以上先
      activeFlag = true;
    }
    return {
      activeFlag
    };
  },
  methods: {
    save: function(event) {
      var childView = this.$refs.regularDisposablesView;
      if (
        this.previousDate &&
        this.previousDate != "0000/00/00" &&
        this.interval
      ) {
        if (childView.checkDisposablesOrder()) {
          childView.$validator.validateAll().then(validatorResult => {
            var isErrorFlg = childView.checkItems();
            if (validatorResult && !isErrorFlg) {
              var returnItems = childView.getItems();
              if (!isErrorFlg) {
                childView.save().then(result => {
                  if (childView.isSuccessEnd()) {
                    this.$parent.close();
                  } else {
                    scrollTo(0, 0);
                  }
                });
              }
              // this.$emit(
              //   "set-regular-disposables-data",
              //   returnItems,
              //   this.$props.index
              // );
              if (!isErrorFlg) {
                this.$parent.close();
              }
            } else {
              scrollTo(0, 0);
            }
          });
        } else {
          // エラーメッセージ表示
          this.showErrorMessage(
            "発送期間が1カ月以内の消耗品は発送できません。<br>" +
              "発送のチェックを外してください。"
          );
          scrollTo(0, 0);
        }
      } else {
        // 前回点検日・顧客出荷日、点検期間が存在しない場合
        // エラーメッセージ表示
        this.showErrorMessage("前回点検日・導入日、発送期間の値がありません。");
        scrollTo(0, 0);
      }
    }
  },
  template: `
      <div>
        <regularDisposablesOder
        ref="regularDisposablesView"
        v-bind:disposablesByDevice="disposablesByDevice"
        v-bind:isSourceInspection="true"
        v-bind:interval="interval"
        v-bind:previousDate="previousDate"
        v-bind:patientCode="patientCode"
        v-bind:patientName="patientName"
        v-bind:isSourcePrescription="true"
        v-bind:isActive="activeFlag"
        v-bind:sendHistoryFlg="this.disposablesByDevice[0].sendHistoryFlg"
        v-bind:inspectionFlg="this.disposablesByDevice[0].inspectionFlg"
        />
        <div style="height: 10px;" />
        <span style="color: red" v-if="this.disposablesByDevice[0].inspectionFlg">
        既に点検済みの為、定期消耗品の変更は「消耗品発送 管理」から実施してください。非定期消耗品については、この画面で登録可能です。
        </span>
        <span style="color: red" v-if="!this.disposablesByDevice[0].sendHistoryFlg && this.disposablesByDevice[0].statusFlag == 1">
        発送月が同じ消耗品が確定済です、発送のチェックを行う場合は「消耗品発送 管理」から実施してください。
        </span>
        <div class="columns" style="height: 10px;">
          <div class="column is-full" style="text-align:center;">
            <b-button
              v-on:click=$parent.close()
              class="button"
              type="is-primary"
              icon-left="keyboard-backspace"
              native-type="button"
              >戻る</b-button>
            <b-button
              v-on:click=save
              class="button"
              type="is-primary"
              native-type="button"
              >登録</b-button>
          </div>
        </div>
      </div>
      `
};

const HeadingCompTemplate = {
  props: ["index", "color", "value1", "value2", "value3", "textStyle", "prefix"],
  template: `
  <div class="columns row" :style="color">
      <div class="column is-1" style="text-align:left; margin-left:10px;">
        <span :style="textStyle">{{prefix}}</span>
      </div>
      <div class="column is-3" style="text-align:left; margin-left:10px;">
        <span :style="textStyle">{{value1}}</span>
      </div>
      <div class="column is-2" style="text-align:left; margin-left:10px;">
        <span :style="textStyle">{{value2}}</span>
      </div>
      <div class="column is-checkBoxCol" style="text-align:left; margin-left:10px;"/>
      <div class="column" style="text-align:left; margin-left:10px;">
        <span :style="textStyle">{{value3}}</span>
      </div>
  </div>
  `,
  data: function() {
    return {};
  },
  created: function() {},
  methods: {}
};

const serialInputModal = {
  props: ["serialList", "serialType", "dName", "dNumber", "machineType"],
  components: {},
  methods: {
    activityType: function() {
      //カメラ機能が使用できるかの判定
      if (
        navigator.platform == "iPad" || // -iOS12
        (navigator.platform == "MacIntel" && // iPadOS
          navigator.userAgent.indexOf("Safari") != -1 &&
          navigator.userAgent.indexOf("Chrome") == -1 &&
          navigator.standalone !== undefined) ||
        navigator.userAgent == "AppGuardian"
      ) {
        return true;
      } else {
        return false;
      }
    },
    serialReader: function(index, serialList) {
      //カメラ呼び出し関数
      if (
        navigator.platform == "iPad" || // -iOS12
        (navigator.platform == "MacIntel" && // iPadOS
          navigator.userAgent.indexOf("Safari") != -1 &&
          navigator.userAgent.indexOf("Chrome") == -1 &&
          navigator.standalone !== undefined) ||
        navigator.userAgent == "AppGuardian"
      ) {
        // iPad
        // さらにWebKit判定を仕込む(UserAgentがAppGuardian)
        if (navigator.userAgent.endsWith("AppGuardian")) {
          // WkWebViewのためiPadアプリ
          // WkWebViewでのカメラアクセスを開始
          // コールバック関数を準備する
          // バーコード読み取り
          this.serialReaderByNative().then(
            function(returnValue) {
              var array = returnValue.split("/");
              // 本来はここでchildFunctionを呼び出すべきだが、Promiseのコールバックで
              // thisは使えないので直接ロジックを実行する
              //品目コードとシリアルのマージ
              if (machineType == 8) {
                // プリズマの場合
                serialList[index + 1].value = array[0];
                serialList[index].value = array[1];
              }
              var productSerial =
                "品目コード:" + array[0] + " " + "S/N:" + array[1];
              serialList[index].value = productSerial;
              if (this.serialType == 0) {
                // 単項目のシリアル読取りの場合
                this.setSerial();
              }
              return;
            }.bind(this)
          );
          if (this.serialType == 0) {
            // 単項目のシリアル読取りの場合
            this.$parent.close();
          }
          return;
        } else {
          // alert("使用可能な環境ではありません。PCブラウザまたはiPadアプリを使用してください。")
          // return;
        }
      } else {
        //追加1
        this.$parent.$parent.isSerialPuroductReaderModalActive = true;
        this.$parent.$parent.serialPuroductListIndex = index;
        this.$parent.$parent.serialPuroductList = this.serialCollection;
      }
    },
    serialReaderByNative: function() {
      var promise = new Promise(function(resolve, reject) {
        // we generate a unique id to reference the promise later
        // from native function
        var promiseId = generateUUID();
        // save reference to promise in the global variable
        nativePromises[promiseId] = { resolve, reject };

        try {
          // call native function
          window.webkit.messageHandlers.callbackHandler.postMessage({
            promiseId: promiseId
          });
        } catch (exception) {
          alert("カメラアクセスでエラーが発生しました");
        }
      });
      return promise;
    },
    addSerial: function() {
      this.serialCollection.push({ value: "" });
    },
    setSerial: function() {
      // 空白の削除
      this.serialCollection = this.serialCollection.filter(
        val => val.value != ""
      );

      var duplication = this.serialCollection.filter(
        (x, y, z) =>
          z.slice(0, z.length).filter(w => w.value == x.value).length >= 2
      );
      if (duplication.length > 0) {
        duplication = duplication.filter(function(v1, i1, a1) {
          return (
            a1.findIndex(function(v2) {
              return v1.value === v2.value;
            }) === i1
          );
        });
        var errMsg = "下記シリアルナンバーの重複が存在します。<br>";
        for (var i in duplication) {
          errMsg = errMsg + duplication[i].value + "<br>";
        }
        this.showErrorMessage(errMsg);
      } else {
        //選択された点検種別を親画面に返却
        this.$emit(
          "serial-input-event",
          this.serialCollection,
          this.dName,
          this.dNumber
        );
        this.$parent.close();
      }
    }
  },
  data() {
    if (this.serialList.length < 1) {
      this.serialList.push({ value: "" });
    }
    var serialCollection = JSON.parse(JSON.stringify(this.serialList));
    // シリアル読取モーダル(兄弟間)とのやり取り用に参照セット
    this.$parent.$parent.serialPuroductList = serialCollection;
    serialCollection = this.$parent.$parent.serialPuroductList;
    return { serialCollection };
  },
  mounted: function() {
    if (this.serialType == 0) {
      if (
        navigator.platform == "iPad" || // -iOS12
        (navigator.platform == "MacIntel" && // iPadOS
          navigator.userAgent.indexOf("Safari") != -1 &&
          navigator.userAgent.indexOf("Chrome") == -1 &&
          navigator.standalone !== undefined) ||
        navigator.userAgent == "AppGuardian"
      ) {
        this.$emit(
          "single-item-serial-reader",
          this.serialCollection,
          this.dName,
          this.dNumber
        );
        this.$parent.close();
      } else {
        // ボンベリストでない場合(点検項目のシリアル読み取り)
        document.getElementById("serialReaderButton").click();
        this.$parent.close();
      }
    }
  },
  template: `<form action="">
              <div class="modal-card" style="width:800px;" >
                <header class="modal-card-head" >
                  <p v-if="serialType == 1" class="modal-card-title" style="color:whitesmoke;" >シリアルナンバー入力</p>
                  <p v-else class="modal-card-title" style="color:whitesmoke;" >シリアルナンバー読み取り</p>
                </header>
                <section class="modal-card-body" style="width:100%;">
                    <tr v-for="(item, col) in serialCollection" v-bind:key="col">
                      <th :rowspan="serialCollection.length" v-if="col==0">
                        <b-button
                          v-if ="serialType==1"
                          style="vertical-align:top; margin-right:10px;"
                          class="button is-primary has-text-centered"
                          icon-left="plus"
                          native-type="button"
                          v-on:click="addSerial()"
                        ></b-button>
                      </th>
                      <td style="width:100%;">
                        <div class="columns">
                          <div class="column" style="width:640px;">
                            <b-input                             
                             expanded
                             style="width:100%; margin-top:20px;"
                             :readonly="serialType!=1"
                             v-model="item.value"
                             data-vv-as="シリアルNo"
                             ></b-input>
                          </div>
                          <div class="column is-one-fifth">                          
                           <b-button                                                   
                              class="button is-primary has-text-centered"
                              style="margin-top:20px;"　　
                              icon-left="camera"
                              native-type="button"
                              id="serialReaderButton"
                              v-on:click="serialReader(col,serialCollection)"
                            >読取</b-button>
                           <b-button
                            v-if="col > 0"
                            style="float:right; margin-left:5px; margin-top:20px;"　
                            class="button is-primary has-text-centered"
                            icon-left="minus"
                            native-type="button"
                            v-on:click="serialCollection.splice(col, 1)"
                            ></b-button>
                          </div>
                        </div>
                      </td>
                    </tr>
                </section>
                <footer class="modal-card-foot">
                  <button class="button" type="button" @click="setSerial">決定</button>
                  <button class="button" type="button" @click="$parent.close()">閉じる</button>
                </footer>
              </div>
            </form>`
};

const serialProductScannerTemplate = {
  props: ["serialType", "index", "dName", "dNumber"],
  data() {
    return {
      productCode: "",
      serialCode: ""
    };
  },
  methods: {
    cancel() {
      this.$parent.close();
    },
    childFunction() {
      var value;
      if (this.productCode || this.serialCode) {
            value =
          "品目コード:" + this.productCode + " " + "S/N:" + this.serialCode;
      } else {
        value = "";
      }
      if (this.serialType == 0) {
        // 選択された点検項目(親画面)に値を返却
        this.$emit(
          "serial-input-event",
          value,
          this.dName,
          this.dNumber,
          this.productCode,
          this.serialCode
        );
      } else {
        // ボンベシリアルリストに値を返却
        this.$parent.$parent.serialPuroductList[this.index].value = value;
        //this.$parent.close();
      }
      this.$parent.close();
    }
  },
  component: {},
  template: `
    <form action="">
      <div class="modal-card" style="width: 1280px; height: 800px;">
        <header class="modal-card-head">
            <p class="modal-card-title" style="color: whitesmoke; text-align: left">交換機器</p>
        </header>
        <section class="modal-card-body">
          <div class="columns">
            <div class="column is-one-seconds">
              <b-field label="品目コード" horizontal>
                <b-input                
                placeholder="品目コードを入力してください。"
                v-model="productCode"></b-input>
              </b-field>
            </div>
            <div class="column is-one-seconds">
              <b-field label="シリアルNo." horizontal>
                <b-input                
                placeholder="シリアルナンバーを入力してください。"
                v-model="serialCode"></b-input>
              </b-field>
            </div>
          </div>
          <div style="width: 1240px; height: 550px;"/>
        </section>
        <footer class="modal-card-foot">
          <b-button class="button" type="button" v-on:click="cancel()">戻る</b-button>
          <b-button class="button" type="button" v-on:click="childFunction()">決定</b-button>
        </footer>
      </div>
    </form>
    `
};

const serialScannerTemplate = {
  props: [],
  data() {
    return {
      newProductCode: null,
      newSerialNumber: null
    };
  },
  methods: {
    cancel() {
      this.$parent.close();
    },
    childFunction(newProductCode, newSerialNumber) {
      if (newProductCode && newSerialNumber) {
        newProductCode = this.spaceDelete(newProductCode);
        newSerialNumber = this.spaceDelete(newSerialNumber);

        this.$emit(
          "resolve",
          newProductCode,
          newSerialNumber
        );
        this.$parent.close();
      } else {
        this.showErrorMessage("未入力の項目があります。");
      }
    },
  },
  component: {},
  template: `
    <form action="">
      <div class="modal-card" style="width: 1280px; height: 800px;">
        <header class="modal-card-head">
            <p class="modal-card-title" style="color: whitesmoke; text-align: left">交換機器</p>
        </header>
        <section class="modal-card-body">
          <div class="columns">
            <div class="column is-one-seconds">
              <b-field label="品目コード" horizontal>
                <b-input
                id="product-code"
                placeholder="交換する機器の品目コードを入力してください。"
                v-model="newProductCode"></b-input>
              </b-field>
            </div>
            <div class="column is-one-seconds">
              <b-field label="シリアルNo." horizontal>
                <b-input
                id="serial-number"
                placeholder="交換する機器のシリアルナンバーを入力してください。"
                v-model="newSerialNumber"></b-input>
              </b-field>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
          <b-button class="button" type="button" v-on:click="cancel()">戻る</b-button>
          <b-button class="button" type="button" v-on:click="childFunction(newProductCode,newSerialNumber)">決定</b-button>
        </footer>
      </div>
    </form>
    `
};

import prescriptionHistoryModal from "./AppPrescriptionHistoryModal";
import * as inspectionUtil from "../utils/inspection"

export default {
  name: "AppPrescriptionEdit",

  computed: {
    productName: function() {
      let productName = "";
      if (!this.inspectionItem.newProductCode) {
        productName = this.inspectionItem.productName;
      } else {
        const product = this.productMaster.find((elem) => elem.productCode == this.inspectionItem.newProductCode);
        if (product) {
          productName = product.productName;
        }
      }
      return productName;
    },

    hiddenNotSap: function() {
      let hiddenNotSap = false;
      if (inspectionUtil.INSPECTION_HEADER_FULL[this.machineType].getHiddenNotSap) {
        hiddenNotSap = inspectionUtil.INSPECTION_HEADER_FULL[this.machineType].getHiddenNotSap(this.inspectionItem.value);
      }
      return hiddenNotSap;
    },

    hardwareVersion: function() {
      let hardwareVersion = 0;
      if (inspectionUtil.INSPECTION_HEADER_FULL[this.machineType].getHardwareVersion) {
        hardwareVersion = inspectionUtil.INSPECTION_HEADER_FULL[this.machineType].getHardwareVersion(this.inspectionItem.value);
      }
      return hardwareVersion;
    },
  },

  methods: {
    inputValue(item) {
      if (
        this.machineType == 8 &&
        this.prismaAnotherInputItems[item.displayName]
      ) {
        var productElement = this.productMaster.find(
          v => v.productCode == item.value
        );
        var targetItem = this.inspectionItem.value.find(
          val =>
            val.displayName == this.prismaAnotherInputItems[item.displayName]
        );
        if (!targetItem) return;
        targetItem.value = productElement ? productElement.productName : "";
      }
    },
    addStyleBackColor: function(value, name) {
      if (this.isDisable(value, name)) {
        return {
          "background-color": "#E1E1E1"
        };
      }
    },
    limitCheck: function(item, index, machineType) {
      var checkFlg = false;
      if (this.machineType == 8) {
        //プリズマ 上限下限入力値チェック
        var min, max;
        var target = this.limitCollection.filter(
          val => val.key == item.displayName
        );
        if (target && target.length > 0) {
          var minMax = this.limitCollection.filter(
            val => val.value == target[0].value
          );
          if (minMax && minMax.length == 2) {
            minMax.forEach(value => {
              switch (value.type) {
                case "min":
                  min = this.inspectionItem.value.filter(
                    val => val.displayName == value.key
                  );
                  break;
                case "max":
                  max = this.inspectionItem.value.filter(
                    val => val.displayName == value.key
                  );
                  break;
              }
            });
          }
          if (
            min.length > 0 &&
            min[0].value &&
            max.length > 0 &&
            max[0].value
          ) {
            if (Number(min[0].value) > Number(max[0].value)) {
              checkFlg = true;
            }
          }
          return checkFlg;
        }
      }
    },
    isDisable: function(value, name) {
      switch (this.machineType) {
        case 8:
          var targetItem = this.disableSelItem.find(val =>
            val.machineType == this.machineType &&
            val.displayName == name &&
            val.value.includes(value)
          );
          if (targetItem) {
            return true;
          }
          break;
      }
      return false;
    },
    getDisposableList: function(patientCode, patientName) {
      this.targetPatientCode = patientCode;
      this.targetPatientName = patientName;

      var excuteApi = this.getNewRegularDisposableListPOST;
      var successCallBack = this.getNewRegularDisposableListPOSTSuccess;
      var errorCallBack = this.getNewRegularDisposableListPOSTError;
      //WebAPI Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getNewRegularDisposableListPOST: function(client) {
      // 器械交換
      return client.apis.apiInspection.getNewRegularDisposableListPOST({
        body: {
          productCode: this.inspectionItem.productCode,
          patientCode: this.inspectionItem.patientCode,
          serial: this.inspectionItem.serialNumber
        }
      });
    },
    getNewRegularDisposableListPOSTSuccess: function(result) {
      // WebAPI応答内容を画面に設定
      this.teikishoumouData.disposablesByDevice = result.obj;
      // 点検期間、前回点検日(or顧客出荷日)を設定
      this.teikishoumouData.interval = result.obj[0].span;
      this.teikishoumouData.previousDate =
        result.obj[0].previousDate != 0
          ? result.obj[0].previousDate
          : "0000/00/00";
      this.isRegularDisposablesOrderModalActive = true;
    },
    getNewRegularDisposableListPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    setDisposablesData(items, index) {
      this.$set(this.data[index], "regularDisposablesProduct", items);
      this.teikishoumouData = {
        disposablesByDevice: "",
        interval: null,
        index: null
      };
    },
    inputRadioValue(index, result) {
      this.inspectionItem.value[index].value = result;
    },
    sortedItemsByDisplayOrder(value) {
      // displayOrderでソート
      return value.sort((a, b) => {
        if ((a.sap && b.sap) || (!a.sap && !b.sap)) {
          // どちらもSAP項目 OR どちらもSAP項目外
          // 表示順で比較
          return a.displayOrder < b.displayOrder
            ? -1
            : a.displayOrder > b.displayOrder
            ? 1
            : 0;
        } else if (a.sap) {
          // SAP項目⇒SAP項目外 の順番の場合
          return -1;
        } else if (b.sap) {
          // SAP項目外⇒SAP項目 の順番の場合
          return 1;
        }
      });
    },
    setPrescriptionMachineValuePOST: function(client) {
      for (var val in this.inspectionItem.value) {
        if (typeof this.inspectionItem.value[val].prescription == "number") {
          this.inspectionItem.value[val].prescription += "";
        }
        if (this.inspectionItem.value[val].prescription == "null") {
          this.inspectionItem.value[val].prescription = null;
        }

        if (
          this.inspectionItem.value[val].value == "" &&
          this.inspectionItem.value[val].prescription != "" &&
          this.inspectionItem.value[val].prescription &&
          !this.inspectionItem.value[val].isClear
        ) {
          this.inspectionItem.value[val].value = this.inspectionItem.value[
            val
          ].prescription;
        }
        delete this.inspectionItem.value[val].isClear;
      }
      if (this.machineType == 6) {
        this.inspectionItem.value.push({ bombeSerialList: this.serialList });
      }
      return client.apis.apiInspection.setPrescriptionMachineValuePOST({
        body: {
          patientCode: this.inspectionItem.patientCode,
          serialNumber: this.inspectionItem.serialNumber,
          productCode: this.inspectionItem.productCode,
          newSerialNumber: this.inspectionItem.newSerialNumber,
          newProductCode: this.inspectionItem.newProductCode,
          mainSetting: this.inspectionItem.mainSetting,
          machineValues: this.inspectionItem.value,
          therapy: this.machineType == 8 ? this.therapy : null
        }
      });
    },
    setPrescriptionMachineValuePOSTSuccess: function(result) {
      // 成功メッセージ表示
      this.showSuccess(result);
    },
    setPrescriptionMachineValuePOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    regist: function() {
      var excuteApi = this.setPrescriptionMachineValuePOST;
      var successCallBack = this.setPrescriptionMachineValuePOSTSuccess;
      var errorCallBack = this.setPrescriptionMachineValuePOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    save(event) {
      this.$validator.validateAll().then(validatorResult => {
        if (validatorResult) {
          // 登録処理
          this.regist().then(result => {
            if (this.searchConditions == undefined) {
              this.$router.push(this.prevRoute.path);
            } else {
              this.$router.push({
                name: "AppInspectionSearch",
                params: { searchConditions: this.searchConditions }
              });
            }
          });
        } else {
          scrollTo(0, 0);
        }
      });
    },
    back(event) {
      if (this.isEdit || this.refer) {
        this.$router.push({
          name: "AppInspectionSearch",
          params: { searchConditions: this.searchConditions }
        });
      } else {
        this.$router.push({
          name: "AppPatientDetail",
          params: {
            code: this.inspectionItem.patientCode,
            searchConditions: this.searchConditions
          }
        });
      }
    },
    getMachineValuePOST: function(client) {
      return client.apis.apiInspection.getMachineValuePOST({
        body: {
          productCode: this.inspectionItem.productCode,
          patientCode: this.inspectionItem.patientCode,
          serial: this.inspectionItem.serialNumber,
          type: 2,
          refMode: !this.isEdit,
        }
      });
    },
    getMachineValuePOSTSuccess: function(result) {
      // WebAPI応答内容を画面に設定
      this.inspectionItem.value = result.obj;
      // SAP⇒SAP以外を画面表示順でソート
      this.sortedItemsByDisplayOrder(this.inspectionItem.value);
      // SAP項目外の始点特定
      var notSAPItem = this.inspectionItem.value.find(val => !val.sap);
      this.notSapItemName = notSAPItem ? notSAPItem.displayName : "";

      // 不要項目「therapy」の削除
      this.inspectionItem.value = this.inspectionItem.value.filter(
        item => Object.keys(item).indexOf("therapy") == -1
      );

      // 機器種別の取得
      this.machineType = this.inspectionItem.value.find(
        item => Object.keys(item).indexOf("reportFormatType") != -1
      ).reportFormatType;

      // 不要項目「reportFormatType」の削除
      this.inspectionItem.value = this.inspectionItem.value.filter(
        item => Object.keys(item).indexOf("reportFormatType") == -1
      );

      //カフⅡの場合
      //プリセット4～9の項目非表示
      if(this.machineType == 11){
        this.inspectionItem.value = this.inspectionItem.value.filter(
          val =>!(val.displayName.indexOf('(プリセット4)') != -1 || 
          val.displayName.indexOf('(プリセット5)') != -1 || 
          val.displayName.indexOf('(プリセット6)') != -1 ||
          val.displayName.indexOf('(プリセット7)') != -1 ||
          val.displayName.indexOf('(プリセット8)') != -1 ||
          val.displayName.indexOf('(プリセット9)') != -1 )
        );
      }

      // 機器がHOTの場合
      if (this.machineType == 6) {
        // ボンベシリアルリストが存在するか確認
        this.serialList = this.inspectionItem.value.find(
          item => Object.keys(item).indexOf("bombeSerialList") != -1
        );
        if (this.serialList) {
          this.serialList = this.serialList.bombeSerialList;

          // ボンベシリアルリストが存在する場合、不要項目として削除
          this.inspectionItem.value = this.inspectionItem.value.filter(
            item => Object.keys(item).indexOf("bombeSerialList") == -1
          );
        } else {
          this.serialList = [];
        }
      }
      // 「処方値変更理由」の場所入れ替え
      var changeReasonIndex = this.inspectionItem.value.findIndex(
        val => val.displayName == "処方値変更理由"
      );
      var notSapIndex = this.inspectionItem.value.findIndex(val => !val.sap);
      const value = this.inspectionItem.value[changeReasonIndex];
      const tail = this.inspectionItem.value.slice(changeReasonIndex + 1);
      this.inspectionItem.value.splice(changeReasonIndex);
      Array.prototype.push.apply(this.inspectionItem.value, tail);
      this.inspectionItem.value.splice(notSapIndex, 0, value);

      // 処方値変更履歴取得
      let _this = this;
      // Web Api Call
      this.apiCall(
        function(client){
          return client.apis.apiInspection.getPrescriptionHistoryListPOST({
            body:{
              productCode: _this.inspectionItem.productCode,
              patientCode: _this.inspectionItem.patientCode,
              serial: _this.inspectionItem.serialNumber,
            }
          });
    },
        function(result) {
          // 検索結果取得
          // TODO:
          _this.preEditHistoryList = result.obj
          if(_this.preEditHistoryList.length > 0){
            _this.lastPreEditHistory = _this.preEditHistoryList[_this.preEditHistoryList.length-1]
          }
        },
        function(result) {
          // エラーメッセージ表示
          _this.showErrorMessage(result);
        },
      );
    },
    serialInputType: function(displayName) {
      //シリアルNo読み取り画面(ret=2) or シリアルナンバー入力画面(ret=1)に遷移するボタンを出力する項目か判定
      if (displayName == "携帯用酸素ボンベ（本数）") {
        return 1;
      } else if (this.serialDisplayNameList.indexOf(displayName) != -1) {
        return 2;
      }
      return "";
    },
    serialInput: function(content, index) {
      //単体、複数のシリアル項目切り分け(serialTypeが1の場合、複数)
      var serialType = 0;
      var newList = [];
      if (content.displayName == "携帯用酸素ボンベ（本数）") {
        serialType = 1;
        this.serialInputModalActive.list = this.serialList;
      } else {
        newList.push({ value: content.value });
        this.serialInputModalActive.list = newList;
      }
      this.serialInputModalActive.index = index;
      this.serialInputModalActive.serialType = serialType;
      this.serialInputModalActive.dName = content.displayName;
      this.serialInputModalActive.dNumber = content.displayOrder;
      this.serialInputModalActive.flg = true;
    },
    serialChanged: function(value, name, number, productCode, serialCode) {
      if (name == "携帯用酸素ボンベ（本数）") {
        // ボンベシリアルリスト
        this.serialList = value;
      } else {
        if (this.machineType == inspectionUtil.MACHINE_TYPE.TRILOGY_EVO.code) {
          let serialChangeList = inspectionUtil.SERIAL_CHANGED_INDEX[this.machineType];
          let productInfo = this.getProductInfo(productCode);
          let newDataList = {
            productCode: productCode,
            serialCode: serialCode,
            productName: productInfo.productName,
          };
          for (const element of serialChangeList) {
            this.inspectionItem.value[
              this.serialInputModalActive.index + element.displayOrder
            ].value = newDataList[element.key];
          }
        } else if (this.machineType == 8 || this.machineType == this.MACHINE_TYPE_ASV) {
          // 品目コードセット
          this.inspectionItem.value[
            this.serialInputModalActive.index + 1
          ].value = productCode;
          // シリアルセット
          this.inspectionItem.value[
            this.serialInputModalActive.index
          ].value = serialCode;
          document
            .getElementById(this.serialInputModalActive.index + 1)
            .focus();
        } else {
          // 点検項目のシリアル入力
          // 「シリアルNO」点検項目にシリアルNoを設定
          this.inspectionItem.value[
            this.serialInputModalActive.index
          ].value = value;
        }
      }

      this.serialInputModalActive.flg = false;
      this.serialInputModalActive.index = 0;
      this.serialInputModalActive.list = [];
      this.serialInputModalActive.serialType = 0;
      this.serialInputModalActive.dName = "";
      this.serialInputModalActive.dNumber = "";
      this.serialPuroductListIndex = null;
    },
    getMachineValuePOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    getInputFieldName: function(index) {
      return "input" + index;
    },
    getSelectFieldName: function(index) {
      return "sel" + index;
    },
    getRadioFieldName: function(index) {
      return "radio" + index;
    },
    getPrescriptionValue(value) {
      if (value == "-" || value == "null" || !value) {
        return "";
      } else {
        return value;
      }
    },
    getSelectValue(displayValue, prescription) {
      var value = "";
      for (var i in displayValue) {
        if (displayValue[i].key == prescription) {
          value = displayValue[i].value;
        }
      }
      return value;
    },
    isShowClear(content) {
      let isShowClear = false;
      let prescription = content.prescription;
      let isDisable;

      // 個別判定
      switch (this.reportFormatType) {
        case 1:   // A40(BiPAP)
          switch (content.displayOrder) {
            case 25:  // 加湿器（A40）
              if (content.prescription == "0") {
                prescription = "";
              }
              break;
            case 27:  // 加湿器のSN
              if (content.prescription == " S/N:") {
                prescription = "";
              }
              break;
          }
          break;

        case 2: // BiPAP
          switch (content.displayOrder) {
            case 30:  // APM-100　有無
            case 36:  // 加湿器（BiPAP）
              if (content.prescription == "0") {
                prescription = "";
              }
              break;
            case 31:  // APM-100　S/N
            case 37:  // 加湿器のSN
              if (content.prescription == " S/N:") {
                prescription = "";
              }
              break;
          }
          break;

        case 3: // LTV
          switch (content.displayOrder) {
            case 10:  // 加湿器（LTV）
            case 92:  // 蘇生バッグ　有無
              if (content.prescription == "0") {
                prescription = "";
              }
              break;
            case 11:  // 加湿器のSN
              if (content.prescription == " S/N:") {
                prescription = "";
              }
              break;
          }
          break;

        case 5: // トリロジー
          switch (content.displayOrder) {
            case 114: // 加湿器　有無
              if (content.prescription == "0") {
                prescription = "";
              }
              break;
            case 117: // 加湿器のSN
              if (content.prescription == " S/N:") {
                prescription = "";
              }
              break;
          }
          break;

        case 6: // 酸素濃縮器（HOT）
          switch (content.displayOrder) {
            case 31:  // ボンベ切り替えｷｯﾄ　有無
              if (content.prescription == "0") {
                prescription = "";
              }
              break;
          }
          break;

        case 7: // トリロジーEvo
          isDisable = this.isDisable(null, content.displayName);
          if (isDisable) {
            prescription = "";
          } else {
            switch (content.displayOrder) {
              case 32:  // 加湿器　有無
              case 102: // 酸素使用
              case 108: // 蘇生バッグ　有無
                if (content.prescription == "0") {
                  prescription = "";
                }
                break;
            }
          }
          break;

        case 8: // プリズマ
          isDisable = Object.values(this.prismaAnotherInputItems).includes(content.displayName);
          if (isDisable) {
            prescription = "";
          } else {
            switch (content.displayOrder) {
              case 100: // 酸素有無
              case 119: // 蘇生バッグ　有無
                if (content.prescription == "0") {
                  prescription = "";
                }
                break;
            }
          }
          break;

        case 9: // Inspireフロー
          switch (content.displayOrder) {
            case 19:  // 酸素濃縮器
              if (content.prescription == "0") {
                prescription = "";
              }
              break;
          }
          break;

        case 10:  // A40Pro
          switch (content.displayOrder) {
            case 25:  // 加湿器（A40）
              if (content.prescription == "0") {
                prescription = "";
              }
              break;
            case 27:  // 加湿器のSN
              if (content.prescription == " S/N:") {
                prescription = "";
              }
              break;
          }
          break;

        case 12:  // Luisa
          switch (content.displayOrder) {
            case 292: // 蘇生バッグ　有無
            case 297: // 酸素添加
              if (content.prescription == "0") {
                prescription = "";
              }
              break;
          }
          break;

        default:
          // 処理なし
          break;
      }

      let value;
      switch (content.type) {
        case 'char':
          value = this.getPrescriptionValue(prescription);
          break;
        case 'sel':
          value = this.getSelectValue(content.displayValue, prescription);
          break;
      }
      if (value) {
        isShowClear = true;
      }

      return isShowClear;
    },
    isShowUintLabel(value, unit) {
      let ret = "";
      if (value && value != "-") {
        ret = unit;
      }
      return ret;
    },
    singleItemSerialReader: function(list, name, number) {
      //カメラ呼び出し関数
      // iPad
      // さらにWebKit判定を仕込む(UserAgentがAppGuardian)
      if (navigator.userAgent.endsWith("AppGuardian")) {
        // WkWebViewのためiPadアプリ
        // WkWebViewでのカメラアクセスを開始
        // コールバック関数を準備する
        // バーコード読み取り
        this.serialReaderByNative().then(
          function(returnValue) {
            var array = returnValue.split("/");
            // 本来はここでchildFunctionを呼び出すべきだが、Promiseのコールバックで
            // thisは使えないので直接ロジックを実行する
            //品目コードとシリアルのマージ
            // var productSerial =
            //   "品目コード:" + array[0] + " " + "S/N:" + array[1];
            // list[0].value = productSerial;

            // 単項目のシリアル読取りの場合
            this.serialChanged(array[1], name, number, array[0], array[1]);

            return;
          }.bind(this)
        );
        return;
      }
    },
    serialReaderByNative: function() {
      var promise = new Promise(function(resolve, reject) {
        // we generate a unique id to reference the promise later
        // from native function
        var promiseId = generateUUID();
        // save reference to promise in the global variable
        nativePromises[promiseId] = { resolve, reject };

        try {
          // call native function
          window.webkit.messageHandlers.callbackHandler.postMessage({
            promiseId: promiseId
          });
        } catch (exception) {
          alert("カメラアクセスでエラーが発生しました");
        }
      });
      return promise;
    },
    displaHeading: function (item) {
      let isDisplay = false;
      if (
        this.machineType == this.MACHINE_TYPE_ASV &&
        (
          item.displayName == "加湿器" ||
          item.displayName == "マスクの種類" ||
          item.displayName == "通信モジュール" ||
          item.displayName == "電源コード"
        )
      ) {
        isDisplay = true;
      }

      return isDisplay;
    },

    showSerialReader: function() {
      if (
        navigator.platform == "iPad" || // -iOS12
        (navigator.platform == "MacIntel" && // iPadOS
          navigator.userAgent.indexOf("Safari") != -1 &&
          navigator.userAgent.indexOf("Chrome") == -1 &&
          navigator.standalone !== undefined) ||
        navigator.userAgent == "AppGuardian"
      ) {
        // iPad
        // さらにWebKit判定を仕込む(UserAgentがAppGuardian)
        if (navigator.userAgent.endsWith("AppGuardian")) {
          // WkWebViewのためiPadアプリ
          // WkWebViewでのカメラアクセスを開始
          // コールバック関数を準備する
          // バーコード読み取り
          this.serialReaderByNative().then(
            function(returnValue) {
              var array = returnValue.split("/");
              let newProductCode = array[0];
              let newSerialNumber = array[1];
              this.resolveSerial(newProductCode, newSerialNumber);
              return;
            }.bind(this)
          );
          return;
        }
      } else {
        // MacOS
        // バーコード読み取り
        this.isSerialReaderModalActive = true;
      }
    },

    serialReaderByNative: function() {
      var promise = new Promise(function(resolve, reject) {
        // we generate a unique id to reference the promise later
        // from native function
        var promiseId = generateUUID();
        // save reference to promise in the global variable
        nativePromises[promiseId] = { resolve, reject };

        try {
          // call native function
          window.webkit.messageHandlers.callbackHandler.postMessage({
            promiseId: promiseId
          });
        } catch (exception) {
          alert("カメラアクセスでエラーが発生しました");
        }
      });
      return promise;
    },

    resolveSerial: function(newProductCode, newSerialNumber) {
      const oldHardware = this.hardwares.find((elem) => elem.itemCode == this.inspectionItem.productCode);
      const newHardware = this.hardwares.find((elem) => elem.itemCode == newProductCode);
      if (oldHardware && newHardware && oldHardware.reportFormatType == newHardware.reportFormatType) {
        this.inspectionItem.newProductCode = newProductCode;
        this.inspectionItem.newSerialNumber = newSerialNumber;
      } else {
        this.inspectionItem.newProductCode = null;
        this.inspectionItem.newSerialNumber = null;
        this.showErrorMessage("器械種別が異なるため交換できません。");
      }
      
      return;
    },

    clearSerial: function() {
      this.inspectionItem.newProductCode = null;
      this.inspectionItem.newSerialNumber = null;
      return;
    },

    displayName: function (content) {
      let name = content.displayName;
      switch (this.machineType) {
        case inspectionUtil.MACHINE_TYPE.TRILOGY_EVO.code:
          if (content.contentsType) {
            name = "【設定" + content.contentsType + "】" + name;
          }
          break;

        default:
          break;
      }

      return name;
    },

    getProductInfo: function(productCode) {
      let productInfo = this.productMaster.find(product => product.productCode == productCode);
      return productInfo ? productInfo : "";
    },

    header: function(content) {
      let header
      if (content.contentsType) {
        if (inspectionUtil.INSPECTION_HEADER_FULL[this.machineType].getHardwareVersion) {
          const hardwareVersion = this.hardwareVersion;
          header = inspectionUtil.INSPECTION_HEADER_FULL[this.machineType][hardwareVersion][content.contentsType][content.displayOrder];
        } else {
          header = inspectionUtil.INSPECTION_HEADER_FULL[this.machineType][content.contentsType][content.displayOrder];
        }
      }

      return header;
    },
  },
  data() {
    var inspectionCode = this.$route.params["code"];
    var productCode = this.$route.params["productCode"];
    var productName = this.$route.params["productName"];
    var serialNumber = this.$route.params["serialNumber"];
    var patientCode = this.$route.params["patientCode"];
    var patientName = this.$route.params["patientName"];
    var hospitalName = this.$route.params["hospitalName"];
    var department = this.$route.params["department"];
    var doctorName = this.$route.params["doctorName"];
    var searchConditions = this.$route.params["searchConditions"];
    var isEdit = this.$route.params["edit"];
    var refer = this.$route.params["refer"];
    var therapy = this.$route.params["therapy"];
    var serialDisplayNameList = [
      "2ネット2ハブ（ｵｷｼｼﾞｪﾝｽﾃｰｼｮﾝ5L用）　S/N",
      "APM-100　S/N",
      "オプション拡張バッテリー　シリアルNO",
      "シンプリーゴー予備バッテリシリアルNO",
      "リモコン　S/N",
      "予備バッテリ　着脱式バッテリ(レンタルバッテリー)　S/N",
      "内部着脱式バッテリSN",
      "加湿器のSN",
      "同調装置機種　シリアルNO",
      "外部バッテリ　S/N",
      "外部バッテリー S/N",
      "標準バッテリ（ｼﾝﾌﾟﾘｰｺﾞｰﾐﾆ）　S/N",
      "着脱式バッテリ　 SN",
      "調整装置機種　シリアルNO",
      "購入バッテリ　着脱式バッテリ(購入バッテリー)　S/N",
      "リチウムイオンバッテリ　S/N",
      "ﾊﾞｯﾃﾘｰﾓｼﾞｭｰﾙ　 SN",
      "ボンベ切り替えｷｯﾄ　S/N",
      "加湿器シリアル1(Prog1)",
      "加湿器シリアル2(Prog1)",
      "加湿器シリアル2(Prog1)",
      "加湿器（品目コード＋品目テキスト)",
      "外部バッテリー1",
      "外部バッテリー2",
      "着脱式バッテリ　シリアル番号",
      "予備の着脱式バッテリ　シリアル番号",
      "加湿器シリアル",
      "通信機器シリアル番号"
    ];
    // 注釈項目の定義(プリズマ)
    var annotationItemMap = {
      "Ti timed(Prog1)": "※ 自動または0.2～4.0",
      "ロック時間(Prog1)": "※ OFFまたは0.6～5.0",
      "（目標）換気量(Prog1)": "※ 100～9999",
      "softSTART Tmax(min)(Prog1)": "※ OFFまたは5～45",
      "softSTOP(Prog1)": "※ OFFまたは5～45",
      "リーク上限(Prog1)": "※ OFFまたは0.0～1000.0",
      "圧力上限(Prog1)": "※ OFFまたは0.0～50.0",
      "無呼吸(Prog1)": "※ OFFまたは10～60(5刻み)",
      "１回換気量　下限(Prog1)": "※ OFFまたは0～2000",
      "１回換気量　上限(Prog1)": "※ OFFまたは0～2000",
      "Vti　下限(Prog1)": "※ OFFまたは0～2000",
      "Vti　上限(Prog1)": "※ OFFまたは0～2000",
      "呼吸回数　下限(Prog1)": "※ OFFまたは0.0～100.0",
      "呼吸回数　上限(Prog1)": "※ OFFまたは0.0～100.0",
      "MV　下限(Prog1)": "※ OFFまたは0.0～100.0",
      "MV　上限(Prog1)": "※ OFFまたは0.0～100.0",
      "SpO2　下限(Prog1)": "※ OFFまたは0.0～100.0",
      "SpO2　上限(Prog1)": "※ OFFまたは0.0～100.0",
      "脈拍数　下限(Prog1)": "※ OFFまたは0～999",
      "脈拍数　上限(Prog1)": "※ OFFまたは0～999",
      "Ti timed(Prog2)": "※ 自動または0.2～4.0",
      "ロック時間(Prog2)": "※ OFFまたは0.6～5.0",
      "（目標）換気量(Prog2)": "※ 100～9999",
      "softSTART Tmax(min)(Prog2)": "※ OFFまたは5～45",
      "softSTOP(Prog2)": "※ OFFまたは5～45",
      "リーク上限(Prog2)": "※ OFFまたは0.0～1000.0",
      "圧力上限(Prog2)": "※ OFFまたは0.0～50.0",
      "無呼吸(Prog2)": "※ OFFまたは10～60(5刻み)",
      "１回換気量　下限(Prog2)": "※ OFFまたは0～2000",
      "１回換気量　上限(Prog2)": "※ OFFまたは0～2000",
      "Vti　下限(Prog2)": "※ OFFまたは0～2000",
      "Vti　上限(Prog2)": "※ OFFまたは0～2000",
      "呼吸回数　下限(Prog2)": "※ OFFまたは0.0～100.0",
      "呼吸回数　上限(Prog2)": "※ OFFまたは0.0～100.0",
      "MV　下限(Prog2)": "※ OFFまたは0.0～100.0",
      "MV　上限(Prog2)": "※ OFFまたは0.0～100.0",
      "SpO2　下限(Prog2)": "※ OFFまたは0.0～100.0",
      "SpO2　上限(Prog2)": "※ OFFまたは0.0～100.0",
      "脈拍数　下限(Prog2)": "※ OFFまたは0～999",
      "脈拍数　上限(Prog2)": "※ OFFまたは0～999",
      "Ti timed(Prog3)": "※ 自動または0.2～4.0",
      "ロック時間(Prog3)": "※ OFFまたは0.6～5.0",
      "（目標）換気量(Prog3)": "※ 100～9999",
      "softSTART Tmax(min)(Prog3)": "※ OFFまたは5～45",
      "softSTOP(Prog3)": "※ OFFまたは5～45",
      "リーク上限(Prog3)": "※ OFFまたは0.0～1000.0",
      "圧力上限(Prog3)": "※ OFFまたは0.0～50.0",
      "無呼吸(Prog3)": "※ OFFまたは10～60(5刻み)",
      "１回換気量　下限(Prog3)": "※ OFFまたは0～2000",
      "１回換気量　上限(Prog3)": "※ OFFまたは0～2000",
      "Vti　下限(Prog3)": "※ OFFまたは0～2000",
      "Vti　上限(Prog3)": "※ OFFまたは0～2000",
      "呼吸回数　下限(Prog3)": "※ OFFまたは0.0～100.0",
      "呼吸回数　上限(Prog3)": "※ OFFまたは0.0～100.0",
      "MV　下限(Prog3)": "※ OFFまたは0.0～100.0",
      "MV　上限(Prog3)": "※ OFFまたは0.0～100.0",
      "SpO2　下限(Prog3)": "※ OFFまたは0.0～100.0",
      "SpO2　上限(Prog3)": "※ OFFまたは0.0～100.0",
      "脈拍数　下限(Prog3)": "※ OFFまたは0～999",
      "脈拍数　上限(Prog3)": "※ OFFまたは0～999",
      "加湿器1（品目コード）(Prog1)": "※ R1152359 / R1079739 / R1143625",
      "IPAP(min)/CPAP(Prog1)": "※ 0.0～50.0（0.2刻み）",
      "EPAP(Prog1)": "※ 0.0～50.0（0.2刻み）",
      "EPAPmin（autoST）(Prog1)": "※ 0.0～50.0（0.2刻み）",
      "EPAPmax（autoST）(Prog1)": "※ 0.0～50.0（0.2刻み）",
      "△pinsp．min(autoST)(Prog1)": "※ 0.0～50.0（0.2刻み）",
      "呼吸回数(Prog1)": "※ 0.0～60.0（0.5刻み）",
      "吸気時間(Prog1)": "※ 0.5～4.0",
      "Ti min(Prog1)": "※ 0.2～4.0",
      "Ti max(Prog1)": "※ 0.2～4.0",
      "トリガ手動設定項目 吸気(Prog1)": "※ 1～8",
      "トリガ手動設定項目 呼気(％)(Prog1)": "※ 5～95",
      "△P(Prog1)": "※ 0.2～40.0",
      "deltaP LIAM(Prog1)": "※ 0.2～36.0",
      "Ti LIAM(Prog1)": "※ 1.5～6.0",
      "Te LIAM(Prog1)": "※ 0.5～9.0",
      "継続時間(Prog1)": "※ OFFまたは1～999",
      "回数(Prog1)": "※ 1～10",
      "HFT流量(Prog1)": "※ 5.0～60.0",
      "低フロー酸素(Prog1)": "※ 0.00～60.00",
      "IPAP(min)/CPAP(Prog2)": "※ 0.0～50.0（0.2刻み）",
      "EPAP(Prog2)": "※ 0.0～50.0（0.2刻み）",
      "EPAPmin（autoST）(Prog2)": "※ 0.0～50.0（0.2刻み）",
      "EPAPmax（autoST）(Prog2)": "※ 0.0～50.0（0.2刻み）",
      "△pinsp．min(autoST)(Prog2)": "※ 0.0～50.0（0.2刻み）",
      "呼吸回数(Prog2)": "※ 0.0～60.0（0.5刻み）",
      "吸気時間(Prog2)": "※ 0.5～4.0",
      "Ti min(Prog2)": "※ 0.2～4.0",
      "Ti max(Prog2)": "※ 0.2～4.0",
      "トリガ手動設定項目 吸気(Prog2)": "※ 1～8",
      "トリガ手動設定項目 呼気(％)(Prog2)": "※ 5～95",
      "△P(Prog2)": "※ 0.2～40.0",
      "deltaP LIAM(Prog2)": "※ 0.2～36.0",
      "Ti LIAM(Prog2)": "※ 1.5～6.0",
      "Te LIAM(Prog2)": "※ 0.5～9.0",
      "継続時間(Prog2)": "※ OFFまたは1～999",
      "回数(Prog2)": "※ 1～10",
      "HFT流量(Prog2)": "※ 5.0～60.0",
      "低フロー酸素(Prog2)": "※ 0.00～60.00",
      "IPAP(min)/CPAP(Prog3)": "※ 0.0～50.0（0.2刻み）",
      "EPAP(Prog3)": "※ 0.0～50.0（0.2刻み）",
      "EPAPmin（autoST）(Prog3)": "※ 0.0～50.0（0.2刻み）",
      "EPAPmax（autoST）(Prog3)": "※ 0.0～50.0（0.2刻み）",
      "△pinsp．min(autoST)(Prog3)": "※ 0.0～50.0（0.2刻み）",
      "呼吸回数(Prog3)": "※ 0.0～60.0（0.5刻み）",
      "吸気時間(Prog3)": "※ 0.5～4.0",
      "Ti min(Prog3)": "※ 0.2～4.0",
      "Ti max(Prog3)": "※ 0.2～4.0",
      "トリガ手動設定項目 吸気(Prog3)": "※ 1～8",
      "トリガ手動設定項目 呼気(％)(Prog3)": "※ 5～95",
      "△P(Prog3)": "※ 0.2～40.0",
      "deltaP LIAM(Prog3)": "※ 0.2～36.0",
      "Ti LIAM(Prog3)": "※ 1.5～6.0",
      "Te LIAM(Prog3)": "※ 0.5～9.0",
      "継続時間(Prog3)": "※ OFFまたは1～999",
      "回数(Prog3)": "※ 1～10",
      "HFT流量(Prog3)": "※ 5.0～60.0",
      "低フロー酸素(Prog3)": "※ 0.00～60.00"
    };
    var disableSelItem = [
      {
        machineType: 8,
        displayName: "回路径",
        value: ["12㎜", "15H㎜"]
      }
    ];
    var prismaAnotherInputItems = {
      "加湿器1（品目コード）(Prog1)": "加湿器1（品目テキスト）(Prog1)",
      "加湿器2（品目コード）(Prog1)": "加湿器2（品目テキスト）(Prog1)"
    };
    var limitCollection = [
      //プリズマ Prog1
      { key: "１回換気量　下限(Prog1)", value: 1, type: "min" },
      { key: "１回換気量　上限(Prog1)", value: 1, type: "max" },
      { key: "Vti　下限(Prog1)", value: 2, type: "min" },
      { key: "Vti　上限(Prog1)", value: 2, type: "max" },
      { key: "呼吸回数　下限(Prog1)", value: 3, type: "min" },
      { key: "呼吸回数　上限(Prog1)", value: 3, type: "max" },
      { key: "MV　下限(Prog1)", value: 4, type: "min" },
      { key: "MV　上限(Prog1)", value: 4, type: "max" },
      { key: "SpO2　下限(Prog1)", value: 5, type: "min" },
      { key: "SpO2　上限(Prog1)", value: 5, type: "max" },
      { key: "脈拍数　下限(Prog1)", value: 6, type: "min" },
      { key: "脈拍数　上限(Prog1)", value: 6, type: "max" },
      //プリズマ Prog2
      { key: "１回換気量　下限(Prog2)", value: 7, type: "min" },
      { key: "１回換気量　上限(Prog2)", value: 7, type: "max" },
      { key: "Vti　下限(Prog2)", value: 8, type: "min" },
      { key: "Vti　上限(Prog2)", value: 8, type: "max" },
      { key: "呼吸回数　下限(Prog2)", value: 9, type: "min" },
      { key: "呼吸回数　上限(Prog2)", value: 9, type: "max" },
      { key: "MV　下限(Prog2)", value: 10, type: "min" },
      { key: "MV　上限(Prog2)", value: 10, type: "max" },
      { key: "SpO2　下限(Prog2)", value: 11, type: "min" },
      { key: "SpO2　上限(Prog2)", value: 11, type: "max" },
      { key: "脈拍数　下限(Prog2)", value: 12, type: "min" },
      { key: "脈拍数　上限(Prog2)", value: 12, type: "max" },
      //プリズマ Prog3
      { key: "１回換気量　下限(Prog3)", value: 13, type: "min" },
      { key: "１回換気量　上限(Prog3)", value: 13, type: "max" },
      { key: "Vti　下限(Prog3)", value: 14, type: "min" },
      { key: "Vti　上限(Prog3)", value: 14, type: "max" },
      { key: "呼吸回数　下限(Prog3)", value: 15, type: "min" },
      { key: "呼吸回数　上限(Prog3)", value: 15, type: "max" },
      { key: "MV　下限(Prog3)", value: 16, type: "min" },
      { key: "MV　上限(Prog3)", value: 16, type: "max" },
      { key: "SpO2　下限(Prog3)", value: 17, type: "min" },
      { key: "SpO2　上限(Prog3)", value: 17, type: "max" },
      { key: "脈拍数　下限(Prog3)", value: 18, type: "min" },
      { key: "脈拍数　上限(Prog3)", value: 18, type: "max" }
    ];
    var productMaster = [];
    var checkFlg;
    this.getProductList(productMaster);
    const MACHINE_TYPE_ASV = 13;
    const hardwares = JSON.parse(sessionStorage.getItem("hardwareMaster"));
    const hardware = hardwares.find((elem) => elem.itemCode == productCode);

    return {
      inspectionItem: {
        inspectionCode,
        productCode,
        productName,
        serialNumber,
        patientCode,
        patientName,
        hospitalName,
        department,
        doctorName,
        newProductCode: null,
        newSerialNumber: null,
        mainSetting: this.$route.params.mainSetting,
        value: []
      },
      disableSelItem,
      isComponentModalActive: false,
      isDisposablesOrderModalActive: false,
      searchConditions,
      isEdit,
      refer,
      therapy,
      isRegularDisposablesOrderModalActive: false,
      targetPatientCode: "",
      targetPatientName: "",
      teikishoumouData: {
        disposablesByDevice: "",
        interval: null,
        previousDate: null
      },
      notSapItemName: "",
      serialDisplayNameList,
      serialInputModalActive: {
        flg: false,
        index: 0,
        list: [],
        serialType: 0,
        dName: "",
        dNumber: ""
      },
      serialList: [],
      machineType: null,
      isSerialPuroductReaderModalActive: false,
      serialPuroductListIndex: null,
      serialPuroductList: [],
      annotationItemMap,
      prismaAnotherInputItems,
      productMaster,
      limitCollection,
      checkFlg: false,
      preEditHistoryList: [],
      prescriptionHistoryModalActive:false,
      lastPreEditHistory:{},
      MACHINE_TYPE_ASV,
      isSerialReaderModalActive: false,
      hardwares: hardwares,
      reportFormatType: hardware.reportFormatType,
      trilogyEvoMainSetting: inspectionUtil.TRILOGY_EVO_SETTING,
    };
  },
  components: {
    "regular-disposables-modal": RegularDisposablesTemplate,
    "heading-comp": HeadingCompTemplate,
    "serialInput-modal": serialInputModal,
    "serialProductReader-modal": serialProductScannerTemplate,
    "prescription-history-modal": prescriptionHistoryModal,
    "reader-modal": serialScannerTemplate,
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from;
    });
  },
  mounted: function() {
    var excuteApi = this.getMachineValuePOST;
    var successCallBack = this.getMachineValuePOSTSuccess;
    var errorCallBack = this.getMachineValuePOSTError;
    // WebAPI Call
    this.apiCall(excuteApi, successCallBack, errorCallBack);
  },
  created: function() {
    this.$validator.extend("validationCeheck", {
      getMessage: field => `入力内容に誤りがあります。再度入力してください。`,
      validate: (value, index) => {
        var ret = true;
        var validationRule = this.inspectionItem.value[index].validationRule;
        // 入力値チェック
        var regex = RegExp(validationRule);
        if (!regex.test(value)) {
          var ret = false;
        }
        return ret;
      }
    });
    this.$validator.extend("checkProduct", {
      getMessage: field =>
        `入力された品目コードは品目マスタに存在しません。再度入力してください。`,
      validate: value => {
        var ret = true;
        // 入力値チェック
        var productElement = this.productMaster.find(
          v => v.productCode == value
        );
        if (!productElement) {
          ret = false;
        }
        return ret;
      }
    });
  }
};
</script>

<style lang="scss" scoped>
.header {
  border-bottom: double;
}
.row {
  border-bottom: 1px solid;
}
</style>



// WEBPACK FOOTER //
// src/components/AppPrescriptionEdit.vue